import { modalState } from "libs/atoms";
import React from "react";
import { useRecoilState } from "recoil";

export default function useModal() {
  const [modal, setModal] = useRecoilState(modalState);

  const set = (newModal: React.ReactNode) => {
    setModal(newModal)
  }

  const clear = () => {
    setModal(undefined);
  }

  return {
    modal,
    set,
    clear
  }
}